"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var s = require("./ProductImage.scss");
var WixMedia_1 = require("../WixMedia");
var mediaService_1 = require("@wix/wixstores-client-core/dist/es/src/media/mediaService");
var _ = require("lodash");
var OldProductThumbnail_1 = require("../OldProductThumbnail/OldProductThumbnail");
var DataHook;
(function (DataHook) {
    DataHook["containerDataHook"] = "containerDataHook";
    DataHook["imgDataHook"] = "imgDataHook";
})(DataHook = exports.DataHook || (exports.DataHook = {}));
var ProductImage = /** @class */ (function (_super) {
    tslib_1.__extends(ProductImage, _super);
    function ProductImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { imageLoaded: false };
        _this.getMediaUrl = function (mediaItem, requiredDimensions, isSSR) {
            if (isSSR === void 0) { isSSR = false; }
            var imageMode = _this.props.imageMode;
            return mediaService_1.getMediaUrl(mediaItem, requiredDimensions || mediaItem, {
                isSSR: isSSR,
                imageMode: imageMode,
            });
        };
        _this.onImageLoad = function () {
            var _a = _this.props.imageLoaded, imageLoaded = _a === void 0 ? _.noop : _a;
            imageLoaded();
            _this.setState({ imageLoaded: true });
        };
        _this.getDimensions = function (mediaItem, dimensions) {
            var aspectRatio = mediaItem.width / mediaItem.height;
            return {
                width: dimensions.width || (dimensions.height ? aspectRatio * dimensions.height : null) || OldProductThumbnail_1.DEFAULT_DIMENSION,
                height: dimensions.height || (dimensions.width ? dimensions.width / aspectRatio : null) || OldProductThumbnail_1.DEFAULT_DIMENSION,
            };
        };
        _this.getImageContainerStyle = function () {
            var imageLoaded = _this.state.imageLoaded;
            var _a = _this.props, mediaItem = _a.mediaItem, isSEO = _a.isSEO, dimensions = _a.dimensions, withSSRDimensions = _a.withSSRDimensions;
            var ratioDimensions = _this.getDimensions(mediaItem, dimensions);
            return imageLoaded || isSEO
                ? {}
                : {
                    backgroundImage: "url(" + _this.getMediaUrl(mediaItem, withSSRDimensions ? ratioDimensions : null, true) + ")",
                };
        };
        _this.getImage = function () {
            var _a;
            var _b = _this.props, imageMode = _b.imageMode, _c = _b.className, className = _c === void 0 ? {} : _c, mountedToDOM = _b.mountedToDOM, productName = _b.productName, _d = _b.altText, altText = _d === void 0 ? '' : _d, dimensions = _b.dimensions, mediaItem = _b.mediaItem, _e = _b.imgDataHook, imgDataHook = _e === void 0 ? DataHook.imgDataHook : _e, isSEO = _b.isSEO, _f = _b.hasFixedSize, hasFixedSize = _f === void 0 ? true : _f, _g = _b.withSrcSet, withSrcSet = _g === void 0 ? false : _g;
            var ratioDimensions = _this.getDimensions(mediaItem, dimensions);
            var imageClass = classnames_1.default([
                (_a = {},
                    _a[s.imageBeforeMounted] = !mountedToDOM && !isSEO,
                    _a[s.imageModeFit] = imageMode === 2 /* FIT */,
                    _a[s.imageModeCrop] = imageMode === 1 /* CROP */,
                    _a),
                className,
            ]);
            // noinspection JSRedeclarationOfBlockScope
            var getResizedImageUrl = _this.getMediaUrl;
            return (React.createElement(WixMedia_1.WixMedia, { hasFixedSize: hasFixedSize, imgDataHook: imgDataHook, className: imageClass, widthDimension: ratioDimensions.width, heightDimension: ratioDimensions.height, wixMediaFetcher: { getResizedImageUrl: getResizedImageUrl }, mediaItem: mediaItem, alt: altText || productName, onLoad: _this.onImageLoad, withSrcSet: withSrcSet }));
        };
        _this.checkIfContainerBiggerThenDefaultImage = function () {
            var _a = _this.props, mediaItem = _a.mediaItem, dimensions = _a.dimensions;
            var ratioDimensions = _this.getDimensions(mediaItem, dimensions);
            return mediaItem.width > ratioDimensions.width && mediaItem.height > ratioDimensions.height;
        };
        return _this;
    }
    ProductImage.prototype.render = function () {
        var _a;
        var _b = this.props, imageMode = _b.imageMode, mountedToDOM = _b.mountedToDOM, _c = _b.containerDataHook, containerDataHook = _c === void 0 ? DataHook.containerDataHook : _c, isSEO = _b.isSEO, withSSRDimensions = _b.withSSRDimensions;
        var imageContainerClass = classnames_1.default([
            s.imageContainer,
            (_a = {},
                _a[s.imageContainerWithoutMode] = withSSRDimensions,
                _a[s.imageContainerModeFit] = withSSRDimensions
                    ? imageMode === 2 /* FIT */ && !this.checkIfContainerBiggerThenDefaultImage()
                    : imageMode === 2 /* FIT */,
                _a[s.imageContainerModeCrop] = imageMode === 1 /* CROP */,
                _a),
        ]);
        return (React.createElement("div", { "data-hook": containerDataHook, style: this.getImageContainerStyle(), className: imageContainerClass }, (mountedToDOM || isSEO) && this.getImage()));
    };
    return ProductImage;
}(React.Component));
exports.ProductImage = ProductImage;
//# sourceMappingURL=ProductImage.js.map